import "../styles/founders.css";

type Founder = {
  name: string;
  role: string;
  image: string;
};

const founders: Founder[] = [
  {
    name: "Gabriel Hansen",
    role: "CEO",
    image: "/assets/team/gabriel-hansen.jpg",
  },
  {
    name: "Jayden Flake",
    role: "COO",
    image: "/assets/team/jayden-flake.jpg",
  },
];

export function Founders() {
  return (
    <section className="section founders-section" id="founders">
      <div className="founders-grid">
        {founders.map((founder) => (
          <article className="founders-card" key={founder.name}>
            <img
              className="founders-photo"
              src={founder.image}
              alt={founder.name}
              width={120}
              height={120}
              loading="lazy"
            />
            <h3 className="founders-name">
              {founder.name}, {founder.role}
            </h3>
          </article>
        ))}
      </div>
    </section>
  );
}
